import "./src/styles/global.css";

// <meta name="apple-itunes-app" content="app-id=1464939652"></meta>
// <meta name="google-play-app" content="app-id=app.rytter"></meta>